var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosBehanceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22_525",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22_525)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 38,
    height: 38,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8147 28.1295C19.8147 30.2835 18.2522 30.9643 16.3326 30.9643H11.2991V25.0603H16.433C18.5089 25.0714 19.8147 25.9308 19.8147 28.1295ZM18.9554 18.9442C18.9554 16.9687 17.4263 16.5 15.7299 16.5H11.3103V21.5H16.0759C17.7612 21.5 18.9554 20.7634 18.9554 18.9442ZM33.721 21.5335C31.6786 21.5335 30.317 22.8058 30.183 24.8482H37.125C36.9353 22.7835 35.8638 21.5335 33.721 21.5335ZM49 4.35714V43.6429C49 46.6004 46.6004 49 43.6429 49H4.35714C1.39955 49 -1 46.6004 -1 43.6429V4.35714C-1 1.39955 1.39955 -1 4.35714 -1H43.6429C46.6004 -1 49 1.39955 49 4.35714ZM29.3237 16.0759H38.0067V13.9665H29.3237V16.0759ZM24.5246 28.3862C24.5246 25.6964 23.2522 23.375 20.6183 22.6272C22.5379 21.7121 23.5424 20.6518 23.5424 18.4978C23.5424 14.2344 20.3616 13.1964 16.6897 13.1964H6.58929V34.625H16.9799C20.875 34.6027 24.5246 32.7388 24.5246 28.3862ZM41.4107 26.7344C41.4107 22.1473 38.721 18.3192 33.8661 18.3192C29.1339 18.3192 25.9308 21.8683 25.9308 26.5335C25.9308 31.3661 28.9777 34.6808 33.8661 34.6808C37.5714 34.6808 39.971 33.0179 41.1317 29.4576H37.3705C36.9576 30.7857 35.2946 31.4777 34 31.4777C31.5 31.4777 30.1942 30.0156 30.1942 27.5379H41.3772C41.3884 27.2813 41.4107 27.0022 41.4107 26.7344Z",
    fill: "#0057FF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosBehanceIcon);
export default __webpack_public_path__ + "static/media/logos_behance-icon.27751b10b14c78329d36c205b696a763.svg";
export { ForwardRef as ReactComponent };